// extracted by mini-css-extract-plugin
export default {"baseListPage":"pUtZV","action-bar":"vtrhB","actionBar":"vtrhB","title":"CUhML"};